import axios from '../../axiosNoToast'
import type { PMLUserResponse } from '@/types/pml-users/pml-users'

class PMLUserLoginService {
  async unlockPmlUser(): Promise<PMLUserResponse> {
    const response = await axios.post(`/mortdash/mlm/pml-user/unlock-pml-user`)
    return response.data
  }
}

export default new PMLUserLoginService()
